var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 300",
    style: {
      enableBackground: "new 0 0 392.4 250.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 80.8,
    y1: 1125.988,
    x2: 369.2,
    y2: 1125.988,
    gradientTransform: "matrix(1 0 0 1 0 -1002.1881)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_7_)"
    },
    d: "M358.5,21.6h-267c-5.9,0-10.7,4.8-10.7,10.7v183c0,5.9,4.8,10.7,10.7,10.7h272 c3.1,0,5.7-2.5,5.7-5.7V32.2C369.1,26.4,364.4,21.6,358.5,21.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "354.2,49.7 95.7,49.7 95.7,49.7 95.7,36.9 354.2,36.9 354.2,36.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M95.7,59v150.2c0,1.6,1.3,3,3,3h252.5c1.6,0,3-1.3,3-3V60.4c0-0.7-0.6-1.3-1.3-1.3L95.7,59 L95.7,59z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#494948"
    },
    d: "M348.3,43.3c0,1.7-1.4,3.1-3.1,3.1s-3.1-1.4-3.1-3.1s1.4-3.1,3.1-3.1S348.3,41.6,348.3,43.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000172401665432783596440000012589940677898693532_",
    gradientUnits: "userSpaceOnUse",
    x1: 65.1,
    y1: 1236.6381,
    x2: 384.9,
    y2: 1236.6381,
    gradientTransform: "matrix(1 0 0 1 0 -1002.1881)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000172401665432783596440000012589940677898693532_)"
    },
    d: "M379.2,226H70.9c-3.2,0-5.8,2.5-5.8,5.7 v1.3c0,5.5,4.5,9.9,10.1,9.9l303.2-0.7c5.6,0,6.5-3.8,6.5-9.2v-1.3C384.9,228.5,382.4,226,379.2,226z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M382.4,54.1c0,1.8-1.5,3-3,3v-0.3c0-0.3,0-0.6,0-0.6c0-0.6,0-1.8,0-2.1 C380.3,54.1,381.2,54.1,382.4,54.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A75842"
    },
    d: "M66.6,87.8c-4,14.1-21.5,23.3-35.4,20.8c-8.8-1.6-16.5-7.9-15.7-10.3c0.7-2.3,8.9-0.9,9.5-3.4 c0.4-1.6-2.6-4.4-5.8-5.1c-3.6-0.8-6.1,1.3-8.3-0.5c-0.1-0.1-1.2-1-1.2-2.2c0.1-1.3,1.7-2.3,2.9-2.6c4.5-1.2,7.9,7.2,12.2,6.2 c2.7-0.6,4.6-4.8,3.7-6.2c-0.7-1.1-3.3-0.2-4.1-1.6c-0.3-0.6-0.3-1.3,0-1.8c0.6-0.9,2-1,2.9-0.8c1.3,0.3,1.6,1.4,2.8,2.2 c1.7,1.2,3.8,1,5.2,0.8c6.4-0.8,7.4-14.4,16-17.2c4.2-1.4,9-0.2,12,2.3C70.2,74.5,66.9,87,66.6,87.8L66.6,87.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000138547253985907307890000007911700143442710154_",
    gradientUnits: "userSpaceOnUse",
    x1: 73.7893,
    y1: 1148.2472,
    x2: 67.9842,
    y2: 1101.8239,
    gradientTransform: "matrix(1 0 0 1 0 -1002.8024)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#56EAC5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#5FD8C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#67CAC5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6AC6C5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000138547253985907307890000007911700143442710154_)"
    },
    d: "M81.7,84.7c-3.4-0.4-7.4-0.4-11.5,0.6 c-2.5,0.6-4.7,1.5-4.7,1.5c-1.7,0.8-3.2,1.5-3.2,1.5c-0.3,0.6-1,2-2.7,3c-1.3,0.8-2.5,1-3.2,1.1c-1,0.5-2.7,1.5-3.5,3.4 c-0.6,1.4-0.5,2.6-0.4,3.4c1.1,8.9,7.8,11.6,7.8,11.6c5.8,9.3,19.7,26.8,20.5,22.7C82.8,123.6,81.7,84.7,81.7,84.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000009590617832367506170000010789166014782069127_",
    gradientUnits: "userSpaceOnUse",
    x1: 78.2906,
    y1: 1134.6626,
    x2: 76.1851,
    y2: 1154.0403,
    gradientTransform: "matrix(1 0 0 1 0 -1002.8024)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000009590617832367506170000010789166014782069127_)"
    },
    d: "M72.7,126.5c-2,12.6,9,31,9,31l0.2-38.1 L72.7,126.5L72.7,126.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6BA92"
    },
    d: "M54.5,84.3c0.7,2.5,1.4,5.1,2.1,7.6c0.8,0,2.6-0.2,4.3-1.5c1-0.8,1.6-1.6,2-2.2 c-0.8-2-1.6-4-2.4-6.1c-2.2,0-4.3,0-6.5,0C54.2,82.8,54.3,83.5,54.5,84.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F68D61"
    },
    d: "M60.7,82.5l-1.3-0.4H59h-0.2l-2,1.2L56.7,85c0.2,0.3,1.1,1.6,2.8,2.1c1.2,0.3,2.3,0.2,3.1-0.1 C61.8,85.5,61.2,84,60.7,82.5L60.7,82.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6BA92"
    },
    d: "M60.9,70.7c0.5,1.1,1.4,3.6,1.6,4.2c0.2,0.8,0.4,1.1,0.6,1.9c0.8,2.7,1,2.7,1.3,4 c0.5,2.1,0.8,3.2,0.2,4.1c-0.7,0.9-2,1-4,1.1c-1.4,0.1-2.4,0.1-3.6-0.5c-1.3-0.7-2-1.8-2.3-2.3c0,0-0.1,0.8-0.7,0.5 c-0.6-0.3-2.8-3.2-1.7-3.7c1.1-0.6,2.1,0.9,2.1,0.9l0.6-1C55.2,79.8,54.6,67.3,60.9,70.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M62.3,81.2c0.4,1,1.5,1.5,2.5,1.1c0-0.2-0.1-0.4-0.1-0.6c-0.1-0.4-0.2-0.9-0.3-1.4L62.3,81.2 L62.3,81.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6BA92"
    },
    d: "M80.3,84.6c1.2,0,2.4,0,3.6,0c0.4,0,0.8-0.4,0.7-0.8c0-0.3-0.4-0.6-0.7-0.6l-3.6-0.4 C79.5,83.8,80.3,84.6,80.3,84.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6BA92"
    },
    d: "M80,86.3c1.2,0.1,2.3,0.1,3.4,0.2c0.5,0.1,0.9-0.3,0.9-0.7c0-0.3-0.2-0.6-0.6-0.7 c-1.2-0.2-2.3-0.3-3.5-0.5C79.4,85.4,80.1,86.3,80,86.3L80,86.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6BA92"
    },
    d: "M79.8,87.8c1,0.1,2,0.2,3.2,0.2c0.3-0.1,0.5-0.3,0.6-0.6c0.1-0.3-0.1-0.6-0.3-0.7L80,86.3 C79.5,86.8,79.6,87.4,79.8,87.8L79.8,87.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6BA92"
    },
    d: "M80.3,82.8l3.7-0.2c0.4,0,0.6-0.3,0.6-0.7c0-0.4-0.3-0.7-0.7-0.7c-1.2,0-2.4-0.1-3.6-0.1 C79.7,82.1,80.3,82.8,80.3,82.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6BA92"
    },
    d: "M82.8,127.6c-0.1-0.1-1.5-1-2.7-0.4c-0.3,0.2-0.6,0.4-0.7,0.6l-1.2-0.2l-1.1,4.9 c0.5-0.1,1-0.2,1.5-0.2c0,0.3,0.1,0.5,0.2,0.7c0.6,1,2.5,1.1,4.9,0.5C83.5,131.4,83.2,129.5,82.8,127.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F68D61"
    },
    d: "M82.8,127.6c-0.1-0.1-1.5-1-2.7-0.4l0,0c-0.1,0.8,0,1.2,0,1.2s-0.5,0.9,0.1,1.6c0,0-0.8,1.1-0.1,2.2 c0,0-0.3,0.8-0.2,1.4c0.9,0.3,2.3,0.2,3.9-0.2C83.5,131.4,83.2,129.5,82.8,127.6L82.8,127.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6BA92"
    },
    d: "M81.4,130.7l4.3-0.3c0.5-0.1,0.9-0.6,0.8-1s-0.5-0.7-1-0.7l-4.4-0.1 C80.2,129.9,81.3,130.7,81.4,130.7L81.4,130.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6BA92"
    },
    d: "M81.2,132.8c1.4,0,2.8-0.1,4.1-0.1c0.6,0,1-0.4,1-0.9c0-0.4-0.3-0.7-0.8-0.8l-4.2-0.3 C80.3,131.7,81.2,132.8,81.2,132.8L81.2,132.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6BA92"
    },
    d: "M81,134.6c1.2,0,2.5,0,3.9,0c0.3-0.1,0.6-0.4,0.6-0.7s-0.1-0.7-0.4-0.8c-1.3-0.1-2.6-0.1-3.9-0.2 C80.6,133.5,80.8,134.2,81,134.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6BA92"
    },
    d: "M81.2,128.6c1.5-0.2,2.9-0.4,4.3-0.6c0.4-0.1,0.7-0.5,0.7-0.9c0-0.5-0.4-0.8-0.9-0.8 c-1.5,0.1-2.9,0.2-4.3,0.2C80.4,127.8,81.2,128.6,81.2,128.6L81.2,128.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000045593626899441957440000014969576435407095230_",
    gradientUnits: "userSpaceOnUse",
    x1: 66.4684,
    y1: 1146.8878,
    x2: 60.8273,
    y2: 1101.9431,
    gradientTransform: "matrix(1 0 0 1 0 -1002.8024)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#56EAC5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#5FD8C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#67CAC5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6AC6C5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000045593626899441957440000014969576435407095230_)"
    },
    d: "M59.2,131.8c-5.9-3-8.6-8.3-9.5-11.2 c-2.7-8-1.6-20.1,1.3-24.1c1.5-2.1,3-3,4.3-3.8c-0.4,2.4,0.3,5.9,0.9,9.9c0.8,6.2,2.2,1.7,3.9,4.2c0.3,1.7,2,13.2,4,15.1 c1.9,1.8,12.9,4.2,14.5,4.5v7.5C76.3,134.4,63.4,133.9,59.2,131.8L59.2,131.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078022019928522494840000015751341473744651416_",
    gradientUnits: "userSpaceOnUse",
    x1: 314.9346,
    y1: 148.4756,
    x2: 146.7346,
    y2: 148.4756,
    gradientTransform: "matrix(1 0 0 -1 0 251.2756)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8DF44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#F7D744"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#F7C145"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#F7AA46"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000078022019928522494840000015751341473744651416_)"
    },
    cx: 230.5,
    cy: 102.8,
    r: 84.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC0C2"
    },
    d: "M242.5,65.1v2.7c0,0,0.7,8.4-9.5,9.6s-18.6,1.1-18.3-5.4c0.9-5,2.6-12.8,2.6-16.9 c0-1.5-0.1-3.2-0.4-5l19.8-0.4l5.8,1L242.5,65.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F29EA4"
    },
    d: "M242.6,50.6l-0.1,14.5c-3.3-0.2-6.4-0.5-8.8-1.5C223.4,59.5,217.3,51.9,217,50l19.8-0.4L242.6,50.6 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC0C2"
    },
    d: "M215.5,46.8c2.3,12.5,18.3,12.1,25.1,11.3c1.9-0.2,3.2-0.5,3.2-0.5c2.2-0.6,3.4-4.1,4-8.6 c1.1-9-0.3-22.3-1.8-25.7c-2.3-5.1-6.5-10.6-22.6-6.6S212.5,30.8,215.5,46.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED6B47"
    },
    d: "M250.9,11.5c0,0-7.1-0.5-15.4-4.2c-6.8-3-15.3,0.3-18.1,1.8c0.1-0.5,0.3-1.1,0.7-1.7 c0,0-1.2,0.9-1.4,2.1c-0.1,0.1-0.2,0.2-0.2,0.2s-1.4-0.3-2.3,0.2c0,0,0.6-0.1,0.9,0.3l0.1,0.1c-10.6,5.2-11.5,22-8.1,25.9 c4.1,4.7,9,15.3,9,15.3s1.8-2.5,1-6.6c-0.7-4.1,2.8-4.1,7.2-6c4.5-1.9,0.7-7.1,4.6-10.3c3.9-3.2,18.2-1.3,18-3.8 C252.3,22.8,250.9,12,250.9,11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E9F3FE"
    },
    d: "M268.1,182c-1.7,0.6-3.4,1.2-5.1,1.7c-10.6,3.3-21.8,5-33.4,5c-0.6,0-1.2,0-1.8,0 c-3.5-0.1-6.9-0.3-10.3-0.6l-3.1-67.2l0,0l-0.7-14.6l-0.1-1.6L212.8,87l-0.5-11.4l1.2,0.1l0,0l1.9,0.2l0,0l0.9,0.1l2.1,0.2 l12.6,1.4l0,0l0.5,0.1l3,0.3l1.1,0.1l2,0.2l0,0l2.8,0.3l2.7,0.3l0,0l1.9,0.2l2.4,0.3h0.5l0.5,0.1l3.5,0.4c0,0,1.4,8.6,3.4,21.4 c0.3,1.7,0.5,3.4,0.8,5.2c1,6.3,2.1,13.4,3.3,20.8l0,0C262.5,145.9,265.7,166.5,268.1,182z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#22407A"
    },
    d: "M230.2,163.9c0,0-0.8,11-2.4,24.8c-3.5-0.1-6.9-0.3-10.3-0.6c-1.7-0.2-3.4-0.4-5.1-0.7 c-2.5-0.4-4.9-0.8-7.4-1.4c-4.3-1-8.5-2.2-12.6-3.6c0.1-0.6,0.2-1.3,0.2-1.9c0.1-0.6,0.1-1.2,0.2-1.8c0.2-1.8,0.4-3.7,0.6-5.4l0,0 c0.7-7.5,0.7-14.2-0.5-17.7c-1.7-5.2-4-17.6-5.9-29.8l0,0c-2.5-15.4-4.5-30.5-4.5-30.5L209,70.4l0,0l0,0l3.8,16.7l17.3,76.6 L230.2,163.9L230.2,163.9L230.2,163.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#22407A"
    },
    d: "M313.2,128.4c-7-13.9-43.3-49.5-44.6-50.7v-0.1c0,0-7.1-3.6-16-5.7l0,0c-1.4-0.3-2.8-0.6-4.2-0.8 c-0.3-0.1-0.6-0.1-0.8-0.1l0,0c-0.7-0.1-1.3-0.2-2-0.3c0,0,0.8,3.2,2,8.8c0,0.2,0.1,0.4,0.1,0.6c0.1,0.4,0.2,0.9,0.3,1.4 c3.2,14.7,8.8,42.7,12,71.7v0.1c0.2,2.3,0.5,4.5,0.7,6.8c0,0.1,0,0.1,0,0.1c0.6,6.6,1.4,15.1,2.2,23.6c1.7-0.5,3.4-1.1,5.1-1.7 c1.3-0.4,2.5-0.9,3.7-1.4c1.8-0.7,3.5-1.5,5.2-2.3c-0.3-2.3-0.6-4.7-0.9-7c1.8,0.4,4.3-0.6,4.3-0.6s0.6-0.4,1.5-1.1 C289.2,164.2,319.5,140.9,313.2,128.4z M290.2,134.5c-0.8,2.3-11.3,19.1-15.3,25.3c-0.9-8.9-1.4-17.7-0.9-25 c0.3-4,0.3-8.2,0.1-12.5l0,0c0,0,0.1,0.1,0.2,0.2c8.3,5.3,16,9.8,16,11.8C290.3,134.3,290.3,134.4,290.2,134.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9E9F9"
    },
    d: "M210.8,70.2c-0.1-1.3,6.2-3.2,6.2-3.2s7.2,10.1,19.1,10.3c0,0-3.4,6.7-7.4,8.4 C228.7,85.7,211.2,78.2,210.8,70.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9E9F9"
    },
    d: "M236.1,77c0,0,6.3-3.8,6.3-7.9c0,0,4.1-0.5,5.9,1.5c0,0,1.5,7-0.5,11.1 C247.8,81.7,238.7,80.3,236.1,77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA4C43"
    },
    d: "M231.8,76.4l8.5-2.1c0,0,1.1,0.1,1.1,1.5s-2.4,5.5-3.5,5.8C237,82,229.8,79.3,231.8,76.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E9F3FE"
    },
    d: "M211.8,69.5c-0.1-1.3,4.2-4.1,4.2-4.1s8.3,9.8,20.2,9.9c0,0-3.4,6.7-7.4,8.4 C228.7,83.7,212.1,77.5,211.8,69.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E9F3FE"
    },
    d: "M236.1,75.3c0,0,6.4-3.4,6.4-7.5c0,0,3.8,1.7,5.6,3.7c0,0,1.6,4.4-0.3,8.5 C247.8,80,238.7,78.6,236.1,75.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C65447"
    },
    d: "M252.8,172.6c-0.3,3.3-1.8,6.4-4.2,8.6l-3.8,3.5c-1,0.9-2.4,0.8-3.2-0.3l-4.7-6 c-1.3-1.6-1.8-3.7-1.7-5.7c0.4-4.6,1.3-13.3,1.9-21.8c0.5-6.9,1-13.5,1-17.6c0.1-12.9-2.4-54.2-2.4-54.2l3.1,0.2 c0,0,7.6,16,11.6,37.8c1,5.4,1.7,11.1,2.1,17C252.6,134.1,254.2,157.7,252.8,172.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA4C43"
    },
    d: "M252.8,172.6c-0.3,3.3-1.8,6.4-4.2,8.6l-3.8,3.5c-1,0.9-2.4,0.8-3.2-0.3l-4.7-6 c-1.3-1.6-1.8-3.7-1.7-5.7c0.4-4.6,1.3-13.3,1.9-21.8c8.5-9.6,11.9-23,13.3-33.8c1,5.4,1.7,11.1,2.1,17 C252.6,134.1,254.2,157.7,252.8,172.6z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC0C2"
    },
    d: "M283.1,173v0.5c0,0.7-0.2,1.5-0.6,2.1c-1.8,0.9-3.6,1.8-5.4,2.7c-1.7,0.8-3.4,1.6-5.2,2.3 c-1.8-2.6,0.1-9.5,2.1-12.2c0.6-0.8,1.5-1.2,2.5-1.4c2.3-0.3,4.4,0.8,5.6,2.5C282.7,170.5,283.1,171.7,283.1,173z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#233862"
    },
    d: "M207.5,179.6c-0.6,2.2-1.5,4.3-2.6,6.5c-4.3-1-8.5-2.2-12.6-3.6c0.1-0.6,0.2-1.3,0.2-1.9 c0.1-0.6,0.1-1.2,0.2-1.8c0.2-1.8,0.4-3.7,0.6-5.4l0,0c0.7-7.5,0.7-14.2-0.5-17.7c-1.7-5.2-4-17.6-5.9-29.8 c0.5,0.6,21,27.7,21.7,46.1C208.7,174.3,208.3,176.9,207.5,179.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC0C2"
    },
    d: "M212.3,187.4c-2.5-0.4-4.9-0.8-7.4-1.4c-4.3-1-8.5-2.2-12.6-3.6c-0.6-0.2-1.1-0.4-1.7-0.6 c-1.4-0.5-2.8-1-4.1-1.6c0.6-0.8,1.7-1.6,1.6-3.2c0,0,2.2,1.1,4.7,1.6c0.5,0.1,1,0.2,1.5,0.2c1,0.1,2,0,2.8-0.4 c3.2-1.3,6.8-2.3,10.4,1.1c0.3,0.2,0.5,0.5,0.8,0.8C210.9,183.4,212.1,185.7,212.3,187.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#22407A"
    },
    d: "M209.1,70.3c0,0-0.8,5.5-2,12.3c-1,5.4-2.2,11.7-3.3,16.5c-1.4,5.5-9.2,16.5-16.7,26.6l0,0 c-7.4,9.9-14.6,18.9-15.3,20.9c-1.3,3.4,15.9,19.2,21.7,26.6l0,0c1.2,1.5,1.9,2.7,1.9,3.3c0,0.8-0.4,1.5-1,2.3 c-0.5,0.6-1.1,1.1-1.7,1.7c-0.6,0.5-1.3,0.9-1.9,1.3c-1.4-0.5-2.8-1-4.1-1.6c-10.7-4.4-20.5-10.4-29.3-17.7 c-4.2-4.5-7.2-9.2-7.5-13.9c-0.9-16.5,26.4-56.3,31.7-66.1C186.7,72.9,208.5,70.4,209.1,70.3L209.1,70.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#233862"
    },
    d: "M274.1,122.3c0,0,0.1,0.1,0.2,0.2c8.3,5.3,16,9.8,16,11.8c1.1-3.6-9.7-18.6-13.2-21.6 C273.5,109.6,274.1,122.3,274.1,122.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#233862"
    },
    d: "M216,65.4c0,0,16.9,71.6,14.2,98.6c0,0-6.2-28.8-21.2-52.4c0,0,5.5-4.9,5.2-6.6c0,0-4.1-1.2-8-0.4 c0,0,0.4-30.9,2.9-34.1C211.5,67.1,216,65.4,216,65.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#233862"
    },
    d: "M242.5,67.8c-0.3-0.3,16.8,70,18.2,92.3c0,0-1.7-39.9-1.5-51.4c0,0-5.8-4-5.8-5.3s6.3-4.6,6.3-4.6 s-4.7-24.6-7.3-27.3C249.7,68.8,242.5,67.8,242.5,67.8z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M248,44.4c0,2.2-0.4,4.8-0.7,6.3c0,1.1-0.4,1.8-0.4,2.6c-4.4-0.4-8.5-4.1-8.5-8.9H248z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.1c435fc5.svg";
export { ForwardRef as ReactComponent };